// Cabeçalho de marca dos documentos impressos (BDM, boletim, proposta): logo/cores da entidade emitente.
export const bdmVars = (emp) => (emp?.cor_primaria ? { "--bdm-cor": emp.cor_primaria, "--bdm-sec": emp.cor_secundaria || "#E8EEF5", "--bdm-th-fg": "#FFFFFF" } : {});

export function BdmBrand({ emp, fallbackSub = "Sistema de Planejamento e Controle" }) {
  const nome = emp?.razao_social || emp?.nome || "OSTECNO VIAS";
  const sub = emp ? [emp.cnpj && `CNPJ ${emp.cnpj}`, emp.endereco, [emp.cidade, emp.uf].filter(Boolean).join("/"), emp.telefone, emp.email, emp.site].filter(Boolean).join(" · ") : fallbackSub;
  return (
    <div className="bdm-brand" data-testid="bdm-brand">
      {emp?.logo ? <img src={emp.logo} alt={nome} className="bdm-logo-img" data-testid="bdm-logo-img" /> : <div className="bdm-logo">{(emp?.nome || "PCP").slice(0, 3).toUpperCase()}</div>}
      <div>
        <div className="bdm-brand-title">{nome}</div>
        {emp?.nome_fantasia && emp.nome_fantasia !== nome && <div className="bdm-brand-sub" style={{ fontWeight: 600 }}>{emp.nome_fantasia}</div>}
        <div className="bdm-brand-sub">{sub}</div>
      </div>
    </div>
  );
}
